const LogMethods = Object.freeze({
  LOG: "log",
  ERROR: "error",
});

export const LogLevel = Object.freeze({
  NONE: 0,
  INFO: 2,
  ERROR: 4,
});

export class Logger {
  constructor(tag) {
    this._internalLogger = console;
    this._tag = tag ? `${tag}` : false;
    this._logLevel = window.ENVCONFIG?.log_level || LogLevel.ERROR;
  }

  _log(method, level, message, ...args) {
    if (this._tag) {
      this._internalLogger[method](`${level} for ${this._tag}`);
    }
    this._internalLogger[method](`${level}: ${this._tag}${message}`, args);
  }

  info(message, ...args) {
    if (this._logLevel > LogLevel.NONE) {
      this._log(LogMethods.LOG, "INFO", message, args);
    }
  }

  error(message, ...args) {
    if (this._logLevel > LogLevel.INFO) {
      this._log(LogMethods.ERROR, "ERROR", message, args);
    }
  }

  setLevel(level) {
    this._logLevel = level;
  }
}
